<div>
    <div fxLayout="column">
        <div fxFlex="100" fxFlex.xs="100" style="position: relative;width: 100%;
  height: 500px;">
            <img [src]="serverPath7 + imageList[0]" class="primarycss" />
            <div class="secondarynew" fxLayout="column" fxLayoutAlign="end start" fxLayoutAlign.xs="end center">
                <h2>
                    <b>{{name}}</b>
                </h2>
                <p [innerHTML]="shortDescription"></p>
                <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="10px"
                    class="buttonsmobile" fxHide.gt-xs>
                    <button (click)="dynamicFormPopup(this.formId, 'download')" style="background-color:green;">Download
                        Brochure</button>
                    <!-- <button (click)="dynamicFormPopup(this.formId)" style="background-color:rgb(202, 127, 22);">Get A
                        Free Consultation</button> -->
                </div>
            </div>

        </div>




        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" class="price-section">
            <div fxLayout="row" fxLayout.xs="column">
                <h2 class="price-text">Prices Starts From</h2>
                <h1 class="price1">{{ price | currencyConvert }} {{units}}</h1>
            </div>

            <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px" class="buttons" fxHide.xs>
                <button (click)="dynamicFormPopup(this.formId, 'download')" style="background-color:green;">Download
                    Brochure</button>
                <button (click)="dynamicFormPopup(this.formId, 'form')" style="background-color:rgb(202, 127, 22);">Get
                    A Free
                    Consultation</button>
            </div>
        </div>
    </div>

    <div class="padding-10">

    </div>

    <div fxLayout="column" class="container" fxLayoutGap="10px">
        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="30px">
            <div fxFlex="50">
                <img [src]="serverPath7+imageList[1]" style="width: 100%;border-radius: 20px;height: 100%;" />
            </div>

            <div fxFlex="50" class="form-container">
                <h2>REGISTER YOUR INTEREST</h2>


                <div *ngIf="init">
                    <dynamic-form [layout]="1" fxFlex="100" [fields]="regConfig" (formSubmit)="submit($event)">
                    </dynamic-form>
                </div>

            </div>
        </div>


        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="30px">
            <div fxFlex="48" fxFlex.xs="100" fxLayoutGap="10px" fxLayout="column" fxLayoutAlign="space-between start"
                fxLayoutAlign.xs="space-between center">
                <h2 class="floorPlan">
                    <b>{{name}}</b>
                </h2>
                <p class="detailcss" [innerHTML]="description"></p>
                <button (click)="dynamicFormPopup(this.formId, 'form')" *ngIf="downloadBrochureEnable"
                    class="button2">Get A Free Consultation</button>
            </div>
            <div fxFlex="50" style="margin: 10px;">
                <img [src]="serverPath7+imageList[2]" style="width: 100%;border-radius: 20px;height: 100%;" />
            </div>
        </div>

        <div class="bannerpadding">
            <h2 style="text-align: center;" class="floorPlan">
                <span class="boldfont">Payment</span>
                <span class="normalfont">Plan</span>
            </h2>
            <div class="background-opacity">
                <div fxLayout="row wrap" fxLayoutAlign="space-around center"
                    class="elementor-element elementor-element-86a6e57 e-con-full e-flex e-con e-child"
                    [style.backgroundImage]="'url(' + serverPath7 + imageList[3] + ')'">
                    <div class="overlay"></div>
                    <div fxFlex="33.33" fxFlex.xs="50" style="margin-bottom: 5px;" *ngFor="let items of specificationList2; let i = index"  class="item-container"
                        [ngClass]="{ 'border-between': i < specificationList2.length - 1 }">
                        <div>
                            <h2 class="percentage">{{ items.name }}</h2>
                            <h3 class="description">{{ items.customField1 }}</h3>
                        </div>
                    </div>
                </div>
            </div>




            <div *ngIf="downloadBrochureEnable" style="text-align: center;">
                <button (click)="dynamicFormPopup(this.formId, 'form')" class="button2">Get A Free Consultation</button>
            </div>
        </div>

        <div class="project-facts-container" fxLayout="row" fxLayout.xs="column" fxLayoutGap="30px">

            <div fxFlex="50" class="image-section">
                <img [src]="serverPath7+imageList[4]" style="width: 100%;border-radius: 20px; height: 100%;" />
            </div>

            <div fxFlex="50" class="facts-section" fxLayout="column" fxLayoutAlign="start stretch">
                <h2 style="text-align: center;" class="floorPlan">
                    <span class="boldfont">Project</span>
                    <span class="normalfont">Facts</span>
                </h2>

                <div *ngFor="let fact of spec | keyvalue" fxLayout="column" fxLayoutAlign="start">
                    <div class="fact-item">
                        <span class="fact-label padding-10">
                            {{ fact.key }}
                        </span>
                    </div>
                    <div style="margin-left: 15px; padding-bottom: 10px; font-size: 17px;">
                        <span class="fact-value">
                            {{ fact.value }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="bannerpadding">

            <div [style.backgroundImage]="'url(' + serverPath7 + imageList[5] + ')'"
                style="height: 200px; position: relative; border-radius: 20px; background-size: cover; background-position: center; overflow: hidden;">

                <div class="overlay2"></div>
                <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" class="secondarynew1"
                    style="height: 100%; display: flex; align-items: center; position: relative; z-index: 1;">
                    <div *ngFor="let item of specificationList; let i = index">
                        <div fxFlex="100" fxLayoutAlign="center" *ngIf="item.specificationType == '4'">
                            <h2 style="text-align: center; color: white;">{{ item.name }}</h2>
                        </div>
                    </div>
                    <div *ngIf="downloadBrochureEnable" fxFlex="50">
                        <button (click)="dynamicFormPopup(this.formId, 'form')" class="button2">Get A Free
                            Consultation</button>
                    </div>
                </div>
            </div>



        </div>

    </div>

    <div>
        <h2 style="text-align: center;" class="floorPlan">
            <span class="boldfont">Amenities</span>
            <span class="normalfont">& Facilities</span>
        </h2>
        <div [style.backgroundImage]="'url(' + serverPath7+imageList[6] + ')'"
            style="background-size: cover; background-repeat: no-repeat; position: relative;">
            <div class="overlay1"></div>
            <div fxLayoutAlign="center center"
                style="top: 0px; width: 100%; height: 100%;  position: relative; z-index: 1;">
                <div fxLayout="row wrap" fxLayoutGap="5px" fxLayoutAlign="center" class="features-container">
                    <div fxLayout="row wrap" fxLayoutGap="5px" fxLayoutGap.xs="10px" fxLayoutAlign="center"
                        class="features-container">
                        <div *ngFor="let item of specificationList3; let i = index" fxLayout="row" fxFlex="20%"
                            fxFlex.xs="40%" class="feature-item">
                            <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" class="spec-item">
                                <div fxLayout="row" fxLayoutGap="5px" fxLayout.xs="column" fxLayoutAlign="start center"
                                    fxLayoutAlign.xs="center center" *ngIf="item.specificationType == '0'">
                                    <img class="spec-logo2" [src]="serverPathSpecification + item.iconImages"
                                        [alt]="item.iconImages">

                                    <h3 fxLayoutAlign="center center" class="feature-label">{{ item.name}}</h3>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>


    <div *ngIf="galleriesEnable" fxLayoutAlign="center center">
        <h2 style="text-align: center;" class="floorPlan">
            <span class="boldfont">Discover</span>
            <span class="normalfont">Galleries</span>
        </h2>
    </div>

    <div *ngIf="galleriesEnable">

        <div fxFlex="100" class="padding-10">
            <mat-tab-group (selectedTabChange)="onTabChange($event)">
                <mat-tab label="Exterior">
                    <div *ngIf="exteriorEnable">
                        <owl-carousel-o *ngIf="carouselVisible" [options]="LogoSlider">

                            <ng-container *ngFor="let item of exterior">
                                <ng-template carouselSlide>
                                    <div (click)="openImageDialog(exterior)">
                                        <img style="padding: 10px; border-radius: 15%; width: 100%;"
                                            [src]="serverPath1 + item.imageName">
                                    </div>

                                </ng-template>
                            </ng-container>

                        </owl-carousel-o>
                    </div>

                </mat-tab>

                <mat-tab label="Interior">
                    <div *ngIf="interiorEnable">
                        <owl-carousel-o *ngIf="carouselVisible" [options]="LogoSlider">

                            <ng-container *ngFor="let item of interior">
                                <ng-template carouselSlide>
                                    <div (click)="openImageDialog(interior)">
                                        <img style="padding: 10px; border-radius: 15%; width: 100%;"
                                            [src]="serverPath1 + item.imageName">
                                    </div>

                                </ng-template>
                            </ng-container>

                        </owl-carousel-o>


                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>


    </div>


    <div *ngIf="amenitiesEnable" fxLayoutAlign="center center">
        <h2 style="text-align: center;" class="floorPlan">
            <span class="boldfont">Floor</span>
            <span class="normalfont">Plans</span>
        </h2>
    </div>

    <div *ngIf="amenitiesEnable">
        <div fxLayout="row" fxLayoutWrap fxLayoutGap="10px" fxLayoutAlign="center center">
            <!-- <div *ngFor="let item of parsedCustomField5; let i = index" fxLayout="column" fxLayoutAlign="center center">
                <span *ngIf="item.value[0]?.imageName">
                    <button
                        [ngStyle]="{ 'background-color': activeIndex === i ? 'green' : 'bisque', color: activeIndex === i ? 'white' : 'black' }"
                        (click)="setActiveIndex(item , i)"
                        style="padding: 10px; border-radius: 10px; border-style: none; margin: 5px;">
           
                        {{ removeUnderscores(item.key) }}
                    </button>
                </span>

            </div> -->

            <ng-container *ngFor="let item of parsedCustomField5; let i = index">
                <div 
                  fxLayout="column" 
                  fxLayoutAlign="center center" 
                  *ngIf="item.value[0]?.imageName"
                >
                  <button
                    [ngStyle]="{
                      'background-color': activeIndex === i ? 'green' : 'bisque',
                      color: activeIndex === i ? 'white' : 'black'
                    }"
                    (click)="setActiveIndex(item, i)"
                    style="padding: 10px; border-radius: 10px; border-style: none; margin: 5px;">
                    {{ removeUnderscores(item.key) }}
                  </button>
                </div>
              </ng-container>
              
        </div>

        <div fxLayout="row" fxLayoutAlign="center center" class="container" style="margin-top: 20px;">
            <div *ngIf="activeIndex !== null && getActiveImage()" style="width: 100%;">
                <img [src]="serverPath1 + getActiveImage()" style="width: 100%;" />
            </div>
        </div>
    </div>

    <div *ngIf="downloadBrochureEnable" fxLayoutAlign="center center">
        <div (click)="dynamicFormPopup(this.formId, 'download')" class="dowbloadBrochure">
            Download Floor Plans
        </div>
    </div>

    <div *ngIf="relatedProductsList.length > 0 " style="padding-top: 4%;" fxLayoutAlign="center center">
        <h2>
            Discover More Projects
        </h2>

    </div>

    <div class="container" *ngIf="relatedProductsList?.length > 0 ">

        <calsoft-product-carousel [data]="data" [heightMobile]="productImageHeightMob"
            [widthMobile]="productImageWidthMob" [height]="productImageHeight" [width]="productImageWidth"
            [imageType]="productImageType" [showConfigurableDropdown]="showConfigurableDropdown"
            [showCartIcon]="showCartIcon" [showCartIncremented]="showCartIncremented" [type]="'product'"
            [header]="relatedProductsText" [slidesPerView]="'4'"  [border]="'1'" [displayTitle]="'1'" [products]="relatedProductsList">
        </calsoft-product-carousel>
    </div>

    <div class="container" *ngIf="upSellsProductsList?.length > 0 ">

        <calsoft-product-carousel [heightMobile]="productImageHeightMob" [widthMobile]="productImageWidthMob"
            [data]="data" [height]="productImageHeight" [width]="productImageWidth" [imageType]="productImageType"
            [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon"
            [showCartIncremented]="showCartIncremented" [type]="'product'" [header]="upSellProductsText"
            [products]="upSellsProductsList" [slidesPerView]="'4'"  [border]="'1'" [displayTitle]="'1'">
        </calsoft-product-carousel>
    </div>

    <div class="container" *ngIf="crossSellsProductsList?.length > 0 ">

        <calsoft-product-carousel [heightMobile]="productImageHeightMob" [widthMobile]="productImageWidthMob"
            [data]="data" [height]="productImageHeight" [width]="productImageWidth" [imageType]="productImageType"
            [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon"
            [showCartIncremented]="showCartIncremented" [type]="'product'" [header]="crossSellProductsText"
            [products]="crossSellsProductsList"  [slidesPerView]="'4'" [border]="'1'" [displayTitle]="'1'">
        </calsoft-product-carousel>
    </div>

    <div class="container" *ngIf="recentlyViewedProducts.length > 0 ">

        <calsoft-product-carousel [heightMobile]="productImageHeightMob" [widthMobile]="productImageWidthMob"
            [data]="data" [height]="productImageHeight" [width]="productImageWidth" [imageType]="productImageType"
            [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon"
            [showCartIncremented]="showCartIncremented" [type]="'product'" [urlNavigation]="false"
            [header]="recentlyViewedProductsText" [slidesPerView]="'4'"  [border]="'1'" [displayTitle]="'1'" [products]="recentlyViewedProducts">
        </calsoft-product-carousel>
    </div>




</div>